import { Spinner } from '@/components/ui/Spinner.tsx'

interface Props {
  phase: { key: string, label: string, desc: string }
  num: number
  status: string
}

export function PhaseRow ({ phase, num, status }: Props): React.ReactElement {
  const isCompleted = status === 'completed'
  const isRunning = status === 'running'
  const isPending = !isCompleted && !isRunning

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '12px 20px',
        borderBottom: '1px solid var(--bp-border)',
        background: isCompleted
          ? 'var(--bp-ok-pale)'
          : isRunning
            ? 'var(--bp-accent-pale)'
            : 'transparent',
        opacity: isPending ? 0.45 : 1
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 700,
          flexShrink: 0,
          background: isCompleted
            ? 'var(--bp-ok)'
            : isRunning
              ? 'var(--bp-accent)'
              : 'var(--bp-surface2)',
          color: isCompleted || isRunning ? '#fff' : 'var(--bp-ink3)'
        }}
      >
        {isCompleted
          ? '✓'
          : isRunning
            ? (
              <Spinner width={10} height={10} />
              )
            : (
                num
              )}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--bp-ink)' }}>
          {phase.label}
        </div>
        <div style={{ fontSize: 11, color: 'var(--bp-ink3)', marginTop: 2 }}>{phase.desc}</div>
      </div>
    </div>
  )
}
